/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Popup_BlockedInputs */

const en_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please allow popups for this site to sign in with Google.`)
};

const fr_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez autoriser les pop-ups pour ce site afin de vous connecter avec Google.`)
};

const de_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte erlauben Sie Pop-ups für diese Website, um sich mit Google anzumelden.`)
};

const it_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di consentire i popup per questo sito per accedere con Google.`)
};

const ru_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, разрешите всплывающие окна, чтобы авторизоваться на этом сайте через Google.`)
};

const es_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permita las ventanas emergentes en este sitio para iniciar sesión con Google.`)
};

const zh_cn2_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请允许此网站弹出窗口，以便使用 Google 帐户登录。`)
};

const ja_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google でサインインするには、このサイトのポップアップを許可してください。`)
};

const hi_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया इस साइट पर Google से साइन इन करने के लिए पॉपअप की अनुमति दें।`)
};

const pt_pt2_login_error_popup_blocked = /** @type {(inputs: Login_Error_Popup_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, permita pop-ups para este site para fazer login com o Google.`)
};

/**
* | output |
* | --- |
* | "Please allow popups for this site to sign in with Google." |
*
* @param {Login_Error_Popup_BlockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_popup_blocked = /** @type {((inputs?: Login_Error_Popup_BlockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Popup_BlockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_popup_blocked(inputs)
	if (locale === "de") return de_login_error_popup_blocked(inputs)
	if (locale === "it") return it_login_error_popup_blocked(inputs)
	if (locale === "ru") return ru_login_error_popup_blocked(inputs)
	if (locale === "es") return es_login_error_popup_blocked(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_popup_blocked(inputs)
	if (locale === "ja") return ja_login_error_popup_blocked(inputs)
	if (locale === "hi") return hi_login_error_popup_blocked(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_popup_blocked(inputs)
	return en_login_error_popup_blocked(inputs)
});